import React, { useEffect, useState } from 'react';
import EmailIcon from '@mui/icons-material/Email';
import IconButton from '@mui/material/IconButton';
import Paper from '@mui/material/Paper';
import { useAtomValue, useSetAtom } from 'jotai';
import { isDrawingState, shouldShowSelectionDialogState, validatedParcellesState } from '@/store';
import theme from '@/theme';

export default function ParcelleSelectionCheckCtrl() {
  const validatedGeoJSONParcelles = useAtomValue(validatedParcellesState);

  const setShouldShowSelectionDialog = useSetAtom(shouldShowSelectionDialogState);

  const [disableCheck, setDisableCheck] = useState(true);

  const isDrawing = useAtomValue(isDrawingState);

  useEffect(() => {
    if (isDrawing) {
      setDisableCheck(true);
      return;
    }

    const isEmptySelection = Object.keys(validatedGeoJSONParcelles.features).length === 0;

    setDisableCheck(isEmptySelection);
  }, [validatedGeoJSONParcelles, isDrawing]);

  const onClick = () => {
    setShouldShowSelectionDialog(true);
  };

  return (
    <Paper
      elevation={4}
      sx={{
        p: '2px',
        backgroundColor: disableCheck ? 'grey.50' : theme.palette.secondary.main,
      }}
    >
      <IconButton aria-label="send-project" title="Envoyer le projet" disabled={disableCheck} onClick={onClick}>
        <EmailIcon style={{ color: disableCheck ? null : '#fff' }} />
      </IconButton>
    </Paper>
  );
}
